export const DEFAULT_ARTICLE_SRCSET_WIDTHS = [200, 320, 480, 640, 768, 1024]

export const WIDE_ARTICLE_SRCSET_WIDTHS = [
  320, 480, 640, 768, 1024, 1200, 1600, 2048,
]
